import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { Button, Label, Modal, ModalBody, Spinner } from 'reactstrap';

import { SEND_NOTIFICATION, SEND_NOTIFICATION_EMPTY } from '../../../../../../../store/actions';
import { CreatableInput } from '../../../../../../Common';

export default function NotifyVendor({ onClose, currentSelectedBooking }) {
  const dispatch = useDispatch();

  /* ---------------------------- LOCAL STATES ---------------------------- */
  const [emails, setEmails] = useState([]);

  console.log(
    'emails',
    emails?.map(email => email?.value),
  );

  /* ---------------------------- REDUX STATES ---------------------------- */
  const { sendNotification, sendNotificationLoading } = useSelector(state => ({
    sendNotification: state?.SendNotificationByAdmin?.data,
    sendNotificationLoading: state?.SendNotificationByAdmin?.loading,
  }));

  const handleSubmit = () => {
    dispatch({
      type: SEND_NOTIFICATION,
      payload: {
        data: {
          booking_id: currentSelectedBooking?.id,
          cc: emails?.map(email => email?.value),
          notify_vendor: true,
        },
      },
    });
  };

  useEffect(() => {
    if (sendNotification !== null) {
      dispatch({
        type: SEND_NOTIFICATION_EMPTY,
      });
      onClose();
    }

    return () => {
      dispatch({
        type: SEND_NOTIFICATION_EMPTY,
      });
    };
  }, [sendNotification]);

  return (
    <Modal isOpen={true} centered size="sm">
      <ModalBody>
        <p className="fs-14 text-center" style={{ color: '#001849' }}>
          Send booking reminder email to Vendor - vendor@email.com
        </p>

        <div className="mb-3">
          <Label htmlFor="language" className="form-label">
            CC <span className="text-muted">(Optional)</span>
          </Label>
          <CreatableInput value={emails} setValue={setEmails} valid="email" />
        </div>
      </ModalBody>

      <div className="d-flex justify-content-center mb-4 gap-3">
        {!sendNotificationLoading && (
          <Button color="primary" style={{ fontSize: '14px', width: '100px', borderRadius: '10px' }} onClick={handleSubmit}>
            Yes
          </Button>
        )}

        {sendNotificationLoading && (
          <Button color="primary" style={{ fontSize: '14px', width: '100px', borderRadius: '10px' }}>
            <Spinner className="btn-replacer-spinner" />
          </Button>
        )}

        <Button color="white" style={{ fontSize: '14px', width: '100px', borderRadius: '10px', border: '1px solid #401589' }} onClick={onClose}>
          No
        </Button>
      </div>
    </Modal>
  );
}
